// Transform block tree state jump to block server api
const BlockAnnouncementTransformer = (origin) => {

    const data = { ...origin };

    return data
}

export default BlockAnnouncementTransformer;